import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label, Form, FormGroup
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, DetailPriceProps, Language, NATURAL_SORT_COMPARE_OPTIONS} from "App/constants";
import {
    ConfiguratorProductBuckets, ConfiguratorProductPrice,
    ConfiguratorProductQuickcouplers,
    ConfiguratorProductQuickcouplers1
} from "App/services/api";
import {basketQuickCouplerSelectionChange} from 'App/basket';
import {extractPrice1} from "App/services";
import {ReadMore} from "App/fragments/ReadMore";
import {selectedLang} from "App/helper";
import * as ReactMarkdown from "react-markdown";

interface StateToProps extends CurrencyProps, DetailPriceProps {
    systems: Array<ConfiguratorProductQuickcouplers1>,
    systemId: number | undefined,
    modelId: number | undefined,
    selectedBuckets: Array<ConfiguratorProductBuckets>
}

interface DispatchToProps {
    onSelectQuickCoupler: (systemId: number | undefined, modelId: number | undefined, modelPrice: ConfiguratorProductPrice | undefined, selected: boolean | undefined, bucket: ConfiguratorProductBuckets | undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSelectQuickCoupler: (systemId: number | undefined, modelId: number | undefined, modelPrice: ConfiguratorProductPrice | undefined, selected: boolean | undefined, bucket: ConfiguratorProductBuckets | undefined) => dispatch(basketQuickCouplerSelectionChange(systemId, modelId, modelPrice, selected, bucket)),
})

interface ComponentState {
    isVisible: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: props.selectedBuckets.length>0
    }
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    render() {
        const {i18n, currency, detailPrice, systems, t, onSelectQuickCoupler, systemId, modelId, selectedBuckets} = this.props;
        const language: Language = selectedLang(i18n);
        const filteredSystems: Array<ConfiguratorProductQuickcouplers1> = systems?systems.filter(s => s.quickcouplers&&s.quickcouplers.length):Array<ConfiguratorProductQuickcouplers1>();
        const selectedSystem: ConfiguratorProductQuickcouplers1 | undefined = systemId&&filteredSystems?
            filteredSystems.find((system:ConfiguratorProductQuickcouplers1) => system.quickcouplersystemid===systemId)
            :undefined;
        const selectedModel: ConfiguratorProductQuickcouplers | undefined = modelId&&selectedSystem&&selectedSystem.quickcouplers?
            selectedSystem.quickcouplers.find((model:ConfiguratorProductQuickcouplers) => model.quickcouplerid===modelId)
            :undefined;

        const qcSystem: number | undefined = (selectedSystem&&selectedSystem.quickcouplersystemid)||undefined;
        const qcModel: number | undefined = selectedModel&&selectedModel.quickcouplerid||undefined;

        function getModelPrice(quickcouplers: Array<ConfiguratorProductQuickcouplers>, value: number): ConfiguratorProductPrice|undefined {
            const model: ConfiguratorProductQuickcouplers | undefined = quickcouplers.find(m => m.quickcouplerid===value);
            return model?model.price:undefined;
        }

        return filteredSystems&&filteredSystems.length?
            <React.Fragment>
                <CardHeader className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                    <span className="m-0 w-75 float-left title-normal-uppercase">{ t('products.configuration.quickcouplers')}</span>
                    <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible? 'fa-chevron-up' : 'fa-chevron-down')}></i>
                </CardHeader>
                <Collapse isOpen={this.state.isVisible}>
                    <CardBody className="px-5 py-2 bodyslice">
                        <Row className="no-gutters py-2">
                            <Col className="align-items-center">
                                <Form inline>
                                    <FormGroup>
                                        <Label for="qcSystem" className={"text-normal-details light pl-5"}>{ t('products.configuration.chooseqcsystem')}</Label>
                                        <Input type="select" name="qcSystem" id="qcSystem" className={"text-select-details light ml-3"}
                                               value={qcSystem}
                                               onChange={(e) => onSelectQuickCoupler(e.target.value?Number(e.target.value):undefined, undefined, undefined, undefined, undefined)}>
                                                <option key={undefined} value={undefined}>{t('products.configuration.noquickcoupler')}</option>
                                                {
                                                    filteredSystems
                                                        .sort((i1:ConfiguratorProductQuickcouplers1, i2:ConfiguratorProductQuickcouplers1) => (i1.name||'').localeCompare(i2.name||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                                                        .map((system: ConfiguratorProductQuickcouplers1, index: number) =>
                                                            <option key={system.quickcouplersystemid} value={system.quickcouplersystemid}>{system.name}</option>
                                                        )
                                                }
                                            </Input>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                        {
                            selectedSystem&&selectedSystem.quickcouplers?
                                <Row className="no-gutters py-2">
                                    <Col className="align-items-center">
                                        <Form inline>
                                            <FormGroup>
                                                <Label for="qcModel" className={"text-normal-details light pl-5"}>{ t('products.configuration.chooseqcmodel')}</Label>
                                                <Input type="select" name="qcModel" id="qcModel" className={"text-select-details light ml-3"}
                                                       value={qcModel}
                                                       onChange={(e) => onSelectQuickCoupler(qcSystem, e.target.value?Number(e.target.value):undefined, e.target.value?getModelPrice(selectedSystem.quickcouplers, Number(e.target.value)):undefined, undefined, undefined)}>
                                                    <option key={undefined} value={undefined}>{t('products.configuration.noqcmodel')}</option>
                                                    {
                                                        selectedSystem.quickcouplers
                                                            .sort((i1:ConfiguratorProductQuickcouplers, i2:ConfiguratorProductQuickcouplers) => (i1.name||'').localeCompare(i2.name||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                                                            .map((model: ConfiguratorProductQuickcouplers, index: number) =>
                                                                <option key={model.quickcouplerid} value={model.quickcouplerid}>{model.name}</option>
                                                            )
                                                    }
                                                </Input>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                </Row>
                            :null
                        }
                        {
                            selectedModel?
                                <React.Fragment>
                                {
                                    selectedModel.titleml?
                                        <Row key={'title'} className="no-gutters">
                                            <Col className="align-items-center py-2 pl-0">
                                                <Label className="form-check-label text-normal-details light align-middle">{selectedModel.titleml[language]}</Label>
                                                {
                                                    selectedModel.descriptionml?
                                                    <ReadMore marginTop={'mt-0'}>
                                                        <ReactMarkdown className="w-100 text-small-details align-middle light"
                                                                       source={(selectedModel.descriptionml[language]||'').replace(/(?:\r|\n|\\n|\\r)/g, '<br>')}
                                                                       escapeHtml={false} />
                                                    </ReadMore>
                                                    :null
                                                }
                                            </Col>
                                        </Row>:
                                        null
                                }
                                {
                                    selectedModel.buckets?
                                        selectedModel.buckets
                                            .sort((i1:ConfiguratorProductBuckets, i2:ConfiguratorProductBuckets) =>
                                                (i1.titleml[language]||'').localeCompare(i2.titleml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS) ||
                                                ((i1.name||'').localeCompare((i2.name||''), undefined, NATURAL_SORT_COMPARE_OPTIONS)) ||
                                                (i1.bucketid - i2.bucketid)
                                            ).map((bucket: ConfiguratorProductBuckets, index: number) => {
                                                const selected = selectedBuckets.find((value:ConfiguratorProductBuckets) => value.bucketid===bucket.bucketid);
                                                const price: number | null = extractPrice1(bucket.price, currency);
                                                return <Row key={bucket.bucketid} className="no-gutters">
                                                    <Col className={"align-items-center py-2 pr-0 " + detailPrice?"col-sm-9":"col"}>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                checked={!!selected}
                                                                id={"bucketInput" + bucket.bucketid}
                                                                name={"bucketInput" + bucket.bucketid}
                                                                className="align-middle" onChange={(e) => onSelectQuickCoupler(qcSystem, qcModel, qcModel?selectedModel.price:undefined, e.target.checked, bucket)}/>
                                                            <Label for={"bucketInput" + bucket.bucketid}
                                                                   className="form-check-label text-normal-details light align-middle">{bucket.titleml[language]||bucket.name}</Label>
                                                            {
                                                                bucket.name && <Label
                                                                    className="w-100 text-small-details align-middle light m-0">{bucket.name}</Label>
                                                            }
                                                            {
                                                                bucket.descriptionml && bucket.descriptionml[language] &&
                                                                <ReadMore marginTop={'mt-0'}>
                                                                    <ReactMarkdown className="w-100 text-small-details align-middle light"
                                                                                   source={(bucket.descriptionml[language]||'').replace(/(?:\r|\n|\\n|\\r)/g, '<br>')}
                                                                                   escapeHtml={false} />
                                                                </ReadMore>
                                                            }
                                                        </div>
                                                    </Col>
                                                    {
                                                        detailPrice ?
                                                            <Col
                                                                className="align-items-center py-2 pl-0 col-sm-3 text-right">
                                                                <Label
                                                                    className={"text-normal-details uppercase align-middle " + (selected ? "" : "lighter")}>{price ?
                                                                    t('products.configuration.price', {
                                                                        amount: price,
                                                                        unit: currency
                                                                    })
                                                                    : t('products.configuration.pricenotavailable')
                                                                }
                                                                </Label>
                                                            </Col> :
                                                            null
                                                    }
                                                </Row>
                                            })
                                        :null
                                }
                                </React.Fragment>
                                :null
                        }
                    </CardBody>
                </Collapse>
            </React.Fragment>
            : null
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/QuickCouplerConf.tsx